import React from "react";
import {
  Button,
  Card,
  CardStackSection,
  Column,
  Columns,
  Heading,
  IconBackground,
  Stack,
  Text,
  TextLink,
  TrackingProvider,
} from "@origin-digital/ods-core";
import { IconCheck, IconClose } from "@origin-digital/ods-icons";
import content from "./content.json";

export const JointAccountHolderScreen = ({
  hasHardship,
  onStart,
}: {
  hasHardship: boolean;
  onStart?: () => void;
}) => {
  return (
    <CardStackSection>
      <Card padding="medium">
        <Stack space={["large", "xlarge"]}>
          <Stack space={["large", "xlarge"]} alignX="center">
            <img
              src="https://www.originenergy.com.au/cdn/images/originenergy/image/upload/pictograms/pictogram_my-account.svg"
              width={128}
              height={128}
              alt=""
            />
            <Stack space="medium" alignX="center">
              <Heading component="h1" variant="h3" align="center">
                {content.title}
              </Heading>
              <Text component="p" align="center">
                {content.intro}
              </Text>
            </Stack>
          </Stack>
          <Stack space="medium">
            {(["can", "cannot"] as const).map((permission) => (
              <Card
                key={permission}
                outline
                borderRadius="large"
                padding="small"
              >
                <Columns space="medium" alignY="top">
                  <Column width="content">
                    <IconBackground
                      color={permission === "can" ? "positive" : "critical"}
                    >
                      {permission === "can" ? (
                        <IconCheck size="xxsmall" variant="solid" />
                      ) : (
                        <IconClose size="xxsmall" variant="solid" />
                      )}
                    </IconBackground>
                  </Column>
                  <Column>
                    <Stack space="xsmall">
                      <Text component="h2" weight="medium">
                        {content[permission].title}
                      </Text>
                      <Text component="p">{content[permission].body}</Text>
                    </Stack>
                  </Column>
                </Columns>
              </Card>
            ))}
            {hasHardship && (
              // Do not report interactions that reveal hardship status.
              <TrackingProvider onTrackingCapture={() => undefined}>
                <Card
                  backgroundColor="cardBackgroundSecondary"
                  padding="small"
                  borderRadius="large"
                >
                  <Stack space="xsmall">
                    <Text component="h2" weight="medium">
                      {content.hardship.title}
                    </Text>
                    <Text component="p">{content.hardship.body}</Text>
                    <Text component="p">
                      <TextLink
                        id="joint-account-holder-support"
                        data-id="joint-account-holder-support"
                        href="tel:132468"
                      >
                        {content.hardship.contact}
                      </TextLink>
                    </Text>
                  </Stack>
                </Card>
              </TrackingProvider>
            )}
          </Stack>
          <Stack alignX="center">
            <Button
              id="joint-account-holder-add"
              data-id="joint-account-holder-add"
              disabled={!onStart}
              onClick={onStart}
            >
              {content.action}
            </Button>
          </Stack>
        </Stack>
      </Card>
    </CardStackSection>
  );
};
